import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link as RouterLink } from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/Settings';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import AuthService from '../AuthService';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import packageJson from '../../package.json'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function HeaderAppBar() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () =>{
    let service = new AuthService()
    service.logout()
    handleClose()
  }
  
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleClick}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            qrpedir - Monitor de impressão 
          </Typography>

          <Typography variant="caption">
          web {packageJson.version}
          </Typography>
          
        </Toolbar>
      </AppBar>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <RouterLink to="/home" style={{ textDecoration: 'none', color: '#010e59' }} >
          <MenuItem onClick={handleClose}>
            <NotificationsNoneIcon fontSize="small" /> Monitor de impressão 
          </MenuItem>
        </RouterLink>

        <RouterLink to="/configurarImpressoras" style={{ textDecoration: 'none', color: '#010e59'}}>
          <MenuItem onClick={handleClose}>
          <SettingsIcon fontSize="small" /> Configurar impressoras 
          </MenuItem>
        </RouterLink>

        <RouterLink to="/configuracoes" style={{ textDecoration: 'none', color: '#010e59'}}>
          <MenuItem onClick={handleClose}>
          <SettingsIcon fontSize="small" /> Outras configurações
          </MenuItem>
        </RouterLink>
      
        <RouterLink to="/" style={{ textDecoration: 'none', color: '#010e59' }}>
          <MenuItem onClick={logout}><ExitToAppIcon fontSize="small" /> Deslogar</MenuItem>
        </RouterLink>
      </Menu>
    </div>
  );
}